import { Outlet } from "react-router-dom";
import LoginForm from "./scenes/login/LoginForm";
import { useLoginStore } from "./Utils/Store";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../src/theme";
import Topbar from "./scenes/global/Topbar";
import Sidebars from "./scenes/global/Sidebars";

const useAuth = () => {
  const isLogin = useLoginStore((state) => state.isLogin);
  return isLogin;
};

const ProtectedRoutes = () => {
  const [theme, colorMode] = useMode();
  const isAuth = useAuth();

  return isAuth ? (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box className="app">
          <Sidebars />
          <main className="content">
            <Topbar />
            <Outlet />
          </main>
        </Box>
      </ThemeProvider>
    </ColorModeContext.Provider>
  ) : (
    <LoginForm />
  );
};

export default ProtectedRoutes;
